import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons'

import { Form, SidebarModal, SidebarNoticeBox } from '@domain-group/suit-theme'

import useCreditNoteItems from '@hooks/useCreditNoteItems'

import type { CreditNoteItemModel } from '@models/types'

import type { ModalCallbacks } from '@modals/CreateOrEditCreditNoteModal'

import AddCreditNoteItem from './AddCreditNoteItem'
import CreditNoteItem from './CreditNoteItem'

const CreditNoteItems = (props: {
  callbacks: ModalCallbacks,
  creditNote: CreditNoteItemModel,
  newRecord: boolean,
}) => {
  const { callbacks, creditNote, newRecord } = props

  const creditNoteItemsPayload = useCreditNoteItems({
    filters: { credit_note_id: creditNote?.id },
  })

  const { filteredCreditNoteItems, hasFilteredCreditNoteItems } = creditNoteItemsPayload

  return (
    <>
      {!newRecord && (
      <>
        <SidebarModal.Separator boxProps={{ marginTop: 'large' }} />

        <AddCreditNoteItem callbacks={callbacks} creditNoteItem={{ credit_note_id: creditNote?.id }} />
      </>
      )}

      {!newRecord && (
        <Form.Field label="Selected Quote Items">
          {!hasFilteredCreditNoteItems && (
          <SidebarNoticeBox boxProps={{ marginTop: 'medium' }}>
            <SidebarNoticeBox.Title>
              <FontAwesomeIcon icon={faInfoCircle} /> Add Credit Note Items Above
            </SidebarNoticeBox.Title>
          </SidebarNoticeBox>
          )}

          {filteredCreditNoteItems.map(creditNoteItem => (
            <CreditNoteItem key={creditNoteItem.id} creditNoteItem={creditNoteItem} />
          ))}
        </Form.Field>
      )}
    </>
  )
}

export default CreditNoteItems
